import { CloudStore } from "@omni/types/api/store/cloud/store.model";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { ItemStock } from "./components/itemStock.component";

type Props = {
    store?: CloudStore | null;
};

export const DriveInComponent = ({ store }: Props) => {
    if (!isDefined(store)) {
        return null;
    }

    return (
        <div className={cn("tw:mt-4")}>
            {store.productAvailability && (
                <div className={cn("tw:flex tw:justify-between")}>
                    <div>
                        <ItemStock
                            className={cn("tw:mb-0")}
                            shopName={store.shopName}
                            productAvailability={store.productAvailability}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
